module.exports = __webpack_public_path__ + "img/dark_logo.59f06de2.png";